import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListFilter, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';

interface DocumentsToolbarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  filterOpen: boolean;
  onToggleFilter: () => void;
  activeFilterCount: number;
}

const DocumentsToolbar: React.FC<DocumentsToolbarProps> = ({
  searchQuery,
  onSearchChange,
  filterOpen,
  onToggleFilter,
  activeFilterCount,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border bg-card p-2 shadow-sm">
      <div className="relative min-w-[12rem] flex-1">
        <Search
          aria-hidden="true"
          className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
        />
        <Input
          value={searchQuery}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={t('documents.searchPlaceholder')}
          aria-label={t('documents.searchPlaceholder')}
          className="border-transparent bg-muted/40 pl-9"
        />
      </div>

      <Button
        variant={filterOpen ? 'default' : 'outline'}
        onClick={onToggleFilter}
        aria-pressed={filterOpen}
      >
        <ListFilter strokeWidth={1.8} />
        {t('documents.filters')}
        {activeFilterCount > 0 && (
          <Badge
            variant={filterOpen ? 'secondary' : 'default'}
            className="ml-0.5 h-5 min-w-5 justify-center px-1 revy-figure"
          >
            {activeFilterCount}
          </Badge>
        )}
      </Button>
    </div>
  );
};

export default DocumentsToolbar;
